/* eslint-disable no-restricted-syntax */
import {
  Config,
  Helpers,
  IFinalResponse,
  InitializeTypes,
} from '@smiles/core-engine';
import { Services } from '@smiles/core-utils';

const CoreHelpers = Helpers;
const CoreServices = Services;

let { smlsEnv, isDotEnv } = window;

if (smlsEnv.includes('uat')) {
  smlsEnv = smlsEnv.replace(/uat/, 'hml');
}
if (isDotEnv) {
  smlsEnv += '-N';
}
const ENV_CORE = smlsEnv?.toLocaleUpperCase() || 'MOCK';

const configLib: InitializeTypes = {
  service: {
    environment: ENV_CORE as any,
    logger: false,
    timeout: 60000,
    region: 'Brasil',
  },
  channel: 'WEB',
  receiveConstants: true,
  loggerXstate: false,
};

export const constants = {} as any;

const saveAuthToken = async (token: string | null) => {
  if (token) {
    Config.saveTokenAuthUser({ accessToken: token });
  }
};

export function init() {
  return Config.initialize(configLib);
}

export { CoreHelpers, CoreServices, Config, saveAuthToken };
export type { IFinalResponse };
